import React from "react";

function escapeHtml(value) {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function renderNode(node) {
  if (!node) return "";

  if (node.type === "text") {
    let text = escapeHtml(node.text || "");

    if (Array.isArray(node.marks)) {
      node.marks.forEach((mark) => {
        if (mark.type === "bold") text = `<strong>${text}</strong>`;
        if (mark.type === "italic") text = `<em>${text}</em>`;
        if (mark.type === "link") {
          const href = escapeHtml(mark.attrs?.href || "#");
          text = `<a href="${href}" target="_blank" rel="noreferrer">${text}</a>`;
        }
      });
    }

    return text;
  }

  if (node.type === "paragraph") {
    const content = (node.content || []).map(renderNode).join("");
    return `<p style="margin:0 0 12px 0;">${content || "<br/>"}</p>`;
  }

  if (node.type === "bulletList") {
    const content = (node.content || []).map(renderNode).join("");
    return `<ul style="margin:0 0 12px 20px;">${content}</ul>`;
  }

  if (node.type === "orderedList") {
    const content = (node.content || []).map(renderNode).join("");
    return `<ol style="margin:0 0 12px 20px;">${content}</ol>`;
  }

  if (node.type === "listItem") {
    const content = (node.content || []).map(renderNode).join("");
    return `<li>${content}</li>`;
  }

  if (node.type === "hardBreak") {
    return "<br/>";
  }

  if (node.type === "mention") {
    const label =
      node.attrs?.label ||
      node.attrs?.name ||
      node.attrs?.id ||
      "";
    return `<strong>@${escapeHtml(label)}</strong>`;
  }

  if (node.content) {
    return node.content.map(renderNode).join("");
  }

  return "";
}

function renderMessageHtml(body) {
  if (!body) return "";

  let json;

  try {
    json = typeof body === "string" ? JSON.parse(body) : body;
  } catch {
    return escapeHtml(body);
  }

  if (!json || !json.content) return "";

  return json.content.map(renderNode).join("");
}

export default function MessageHtml({ value }) {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: renderMessageHtml(value),
      }}
    />
  );
}